"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _diff = _interopRequireDefault(require("./diff"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var diffDay = function diffDay(firstDate, secondDate) {
  return (0, _diff["default"])('day', (0, _dayjs["default"])(firstDate).startOf('day').toISOString(), (0, _dayjs["default"])(secondDate).startOf('day').toISOString());
};

var _default = diffDay;
exports["default"] = _default;